import React from "react";

import classNames from "classnames";

const ContentBox = ({
  showBorder = true,
  children,
  className = "",
  ...otherProps
}) => (
  <div
    data-testid="content-box"
    className={classNames(
      "cs-ui-content-box",
      { "cs-ui-content-box--show-border": showBorder },
      className
    )}
    {...otherProps}
  >
    {children}
  </div>
);

export default ContentBox;
